import { kadhavuExpUrl } from 'endpoints';
import { setLanguageBundle } from '@nackle/intl-tools';
import { fetch } from '@nackle/umbrella';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    loading: false,
    error: '',
    locales: [
        {
            label: '',
            code: ''
        }
    ],
    userSelectedLocale: ''
};

/*******************************************************************************
 * Non-async action types
 */
export const LOADING_START = 'loading/start';
export const LOADING_END = 'loading/end';
export const SET_ALERT_MESSAGE = 'state/setAlert';
export const CLEAR_ALERT_MESSAGE = 'state/clearAlert';
export const SET_ERROR = 'state/setError';
export const CLEAR_ERROR = 'state/clearError';
export const SET_LOCALES = 'state/setLocales';
export const UPDATE_LOCALE = 'state/updateLocale';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case LOADING_START: {
            return {
                ...state,
                loading: true
            };
        }
        case LOADING_END: {
            return {
                ...state,
                loading: false
            };
        }
        case SET_ALERT_MESSAGE: {
            return {
                ...state,
                alertMessage: {
                    type: action.alertType,
                    text: action.data,
                    message: action.message
                }
            };
        }
        case CLEAR_ALERT_MESSAGE: {
            return {
                ...state,
                alertMessage: {}
            };
        }
        case SET_ERROR: {
            return {
                ...state,
                error: action.data
            };
        }
        case CLEAR_ERROR: {
            return {
                ...state,
                error: []
            };
        }
        case SET_LOCALES: {
            return {
                ...state,
                locales: action.locales
            };
        }
        case UPDATE_LOCALE: {
            return {
                ...state,
                userSelectedLocale: action.locale
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
export function startLoading() {
    return {
        type: LOADING_START
    };
}

export function endLoading() {
    return {
        type: LOADING_END
    };
}
export function setError( data ) {
    return {
        type: SET_ERROR,
        data
    };
}
export function clearError() {
    return {
        type: CLEAR_ERROR
    };
}
export function setAlertMessage( data, alertType, message ) {
    return {
        type: SET_ALERT_MESSAGE,
        alertType: alertType,
        data,
        message
    };
}
export function clearAlertMessage() {
    return {
        type: CLEAR_ALERT_MESSAGE
    };
}

export function setLocales( locales ) {
    return {
        type: SET_LOCALES,
        locales
    };
}

export function updateLocale( locale ) {
    sessionStorage.setItem( 'userSessionLocale', locale );
    return {
        type: UPDATE_LOCALE,
        locale
    };
}

export function getContent( locale ) {
    return ( dispatch ) => {
        dispatch( startLoading() );
        return fetch( `${ kadhavuExpUrl }/content`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(
                {
                    locale: locale, 
                    projects: [ 'kadhavu', 'origami' ]
                }
            )
        } )
            .then( ( res ) => {
                if ( res.ok ) {
                    return res.json().then( ( data ) => {
                        if ( data && !data.errors ) {
                            setLanguageBundle( data.locale, { ...data.properties.kadhavu, ...data.properties.origami } );
                        } else if ( data.errors ) {
                            throw new Error( data.errors[ 0 ].message );
                        }
                    } );
                } else {
                    return res.json().then( ( data ) => {
                        throw new Error( data );
                    } );
                }
            } )
            .finally( () => {
                dispatch( endLoading() );
            } );
    };
}

export function getLocales() {
    return ( dispatch ) => {
        return fetch( `${ kadhavuExpUrl }/locales`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } )
            .then( ( res ) => {
                if ( res.ok ) {
                    return res.json().then( ( data ) => {
                        if ( data && !data.errors ) {
                            dispatch( setLocales( data.locales ) );
                        } else if ( data.errors ) {
                            throw new Error( data.errors[ 0 ].message );
                        }
                    } );
                } else {
                    return res.json().then( ( data ) => {
                        throw new Error( data );
                    } );
                }
            } );
    };
}